import * as React from 'react';
export const IcInfant = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 20a13.648 13.648 0 01-1.57-.11A6 6 0 0018 16v-.09A12 12 0 019 20zm7.52-5.42A7.94 7.94 0 016 13.27V16a6 6 0 00.22 1.6A9.89 9.89 0 009 18a9.998 9.998 0 007.52-3.42zM12 14a6 6 0 100-12 6 6 0 000 12zm2.5-8a1 1 0 110 2 1 1 0 010-2zm-.28 3a1 1 0 01.92.59 1 1 0 01-.14 1.08 4.001 4.001 0 01-5.92 0 1 1 0 01-.18-1.08A1 1 0 019.78 9h4.44zM9.5 6a1 1 0 110 2 1 1 0 010-2z'
      fill='currentColor'
    />
  </svg>
);
